const Consistency = [
  "Formed",
  "Semi-Formed",
  "Soft",
  "Watery",
  "Mucoid",
  "Watery Mucoid",
];

export default Consistency;
